const currentOrganization = state => state.currentOrganization;

export {
   currentOrganization,
}
